export const GET_ALL_COURSES_REQUEST = 'CourseListPage/GET_ALL_COURSES_REQUEST';
export const GET_ALL_COURSES_SUCCESS = 'CourseListPage/GET_ALL_COURSES_SUCCESS';
export const GET_ALL_COURSES_FAILURE = 'CourseListPage/GET_ALL_COURSES_FAILURE';
export const SET_FILTERS = 'CourseListPage/SET_FILTERS';
